<div class="actions" fxLayout="row" fxLayoutAlign="space-between center">
  <div class="buttons">
    <button mat-button color="primary" class="download-btn">
      <a
        class="download-link"
        download="true"
        [href]="getBaseUrl() + '/files/download/pdf/' + file.id"
      ></a>
      <span>دانلود فایل</span>
      <jam-icon name="download"></jam-icon>
    </button>
    <button (click)="unconfirm()" mat-button color="warn">
      <span>اعلام خطا</span>
      <jam-icon name="triangle-danger"></jam-icon>
    </button>
    <button
      [disabled]="this.file.confirmed"
      (click)="confirm()"
      mat-flat-button
      color="primary"
    >
      <span>تایید فایل</span>
      <jam-icon name="check"></jam-icon>
    </button>
  </div>
  <div class="icon-buttons">
    <button mat-icon-button mat-dialog-close color="warn">
      <jam-icon name="close"></jam-icon>
    </button>
  </div>
</div>

<div
  class="admin-document-preview-container"
  fxLayout="row"
  fxLayoutAlign="space-between start"
>
  <div class="main-holder" fxFlex="69">
    <mat-card class="file-content">
      <mat-card-content>
        <div
          class="info-blocks"
          fxLayout="row wrap"
          fxLayoutAlign="space-between start"
        >
          <div
            class="info-block"
            fxFlex="49"
            fxFlex.lt-sm="100"
            fxLayout="column"
          >
            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">شماره کاربری</div>
              <div class="data" fxFlex="50">{{ 11 }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">نام کاربری</div>
              <div class="data" fxFlex="50">{{ file.user.fullName }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">ایمیل یا تلفن</div>
              <div class="data" fxFlex="50">
                {{ file.user.phone || file.user.email || "no@gmail.com" }}
              </div>
            </div>
          </div>

          <div
            class="info-block"
            fxFlex="49"
            fxFlex.lt-sm="100"
            fxLayout="column"
          >
            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">شماره فایل</div>
              <div class="data" fxFlex="50" dir="ltr">{{ file.hash }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">نام فایل</div>
              <div class="data" fxFlex="50">{{ file.name }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">تاریخ ثبت</div>
              <div class="data" fxFlex="50">
                {{ getDate() | jdate : "d mmm yyyy" | digitsEnToFa }}
              </div>
            </div>
          </div>

          <div class="info-block" fxFlex="100" fxLayout="row">
            <div
              class="block description"
              fxFlex="100"
              fxLayout="row"
              fxLayoutAlign="space-between stretch"
            >
              <div class="title" fxFlex="20">توضیحات</div>

              <div class="data" fxFlex="75">
                <p>{{ file.info }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="preview-pages"></div>
        <div class="description"></div>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card class="image-preview" fxFlex="29">
    <img
      *ngIf="!images.length"
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_6gH1TLpuLUR7Lfck78rg0l_PVqDzi7HCgOwgie-DmSFzXRwSwBGPKLGEAW8HPxMrO9U&usqp=CAU"
      alt=""
    />
  </mat-card>
</div>
